import React from 'react';

export const VolLocTypeModal = {
  title: 'Volcano Type',
  body: (
    <div>
      <p>
        The volcano type as listed by the Smithsonian Institution, Global Volcanism Program. For more information please visit the
        {' '}
        <a href="https://volcano.si.edu/" target="_blank" rel="noopener noreferrer">Smithsonian Institution, Global Volcanism Program</a>
        {' '}
        for volcano types and processes gallery.
      </p>
    </div>
  ),
};
